import { useAuthStore } from '../stores/authStore';
import { useAuthStoreHydrated } from './useAuthStoreHydrated';

export const useAuthorization = () => {
  const hasHydrated = useAuthStoreHydrated();
  const user = useAuthStore.getState().user;
  const isAuthenticated = useAuthStore.getState().isAuthenticated;
  const isLoading = useAuthStore.getState().isLoading;
  const error = useAuthStore.getState().error;

  // Métodos
  const login = useAuthStore.getState().login;
  const logout = useAuthStore.getState().logout;
  const updateUser = useAuthStore.getState().updateUser;
  const setLoading = useAuthStore.getState().setLoading;
  const setError = useAuthStore.getState().setError;
  const clearError = useAuthStore.getState().clearError;

  // Métodos de autorización
  const hasPermission = useAuthStore.getState().hasPermission;
  const hasAnyPermission = useAuthStore.getState().hasAnyPermission;
  const hasAllPermissions = useAuthStore.getState().hasAllPermissions;
  const hasRole = useAuthStore.getState().hasRole;
  const getToken = useAuthStore.getState().getToken;
  const isTokenValid = useAuthStore.getState().isTokenValid;

  return {
    // Estado
    user,
    isAuthenticated: hasHydrated ? isAuthenticated : false,
    isLoading: hasHydrated ? isLoading : true,
    error,
    isReady: hasHydrated,

    // Acciones
    login,
    logout,
    updateUser,
    setLoading,
    setError,
    clearError,

    // Autorización
    hasPermission,
    hasAnyPermission,
    hasAllPermissions,
    hasRole,
    getToken,
    isTokenValid,
  };
};
